<template>
  <div class="panel">
    <div class="plan">
      <div>
        <img :src="imgUrl1" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "compensationScheme",
  components: {},
  props: {
    imgUrl: Array
  },
  data() {
    return {
      imgUrl1: ""
    };
  },
  mounted() {
    this.dd();
  },
  destroyed() {},

  methods: {
    dd() {
      this.imgUrl1 = this.imgUrl[3];
    }
  }
};
</script>
<style lang="scss" scoped>
img {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.panel {
  background: #f7f6f9;
  margin: 0.1rem 0.1rem;
  color: #333333;
  font-size: 0.14rem;
}
// @import './compensationScheme.scss'
</style>


// WEBPACK FOOTER //
// src/pages/Index/compensationScheme/index.vue